<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click.prevent>
            <span>
              Department/Branch
              <!-- Danh sách phòng ban/Chi nhánh -->
            </span>
          </a>
        </li>
      </ol>
      <div class="container-fluid">
        <button
          class="btn btn-info mb-2"
          @click.prevent="openItemModal"
          v-if="department_create"
        >
          <i class="fas fa-plus"></i>
          Add
          <!-- Thêm -->
        </button>
        <zk-table
          class="mytable"
          :data="items"
          :columns="columns"
          :stripe="props.stripe"
          :border="props.border"
          :show-header="props.showHeader"
          :show-summary="props.showSummary"
          :show-row-hover="props.showRowHover"
          :show-index="props.showIndex"
          :tree-type="props.treeType"
          :is-fold="props.isFold"
          :expand-type="props.expandType"
          :selection-type="props.selectionType"
          empty-text="Không có dữ liệu"
          children-prop="childs"
        >
          <template slot="action" scope="scope">
            <b-link
              v-if="department_update"
              class="text-primary mr-2"
              href="#"
              @click="openUpdateItemModal(scope.row)"
            >
              <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link
              class="text-danger"
              v-if="department_delete"
              href="#"
              @click="deleteItem(scope.row)"
            >
              <i class="fas fa-trash"></i>
            </b-link>
          </template>
        </zk-table>
        <!-- <b-table bordered head-variant="dark" hover responsive :fields="fields" :items="items">
          <template v-slot:cell(tendonvi)="data">
            <div v-html="data.value"></div>
          </template>
        </b-table>-->
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="lg"
      @ok="storeItem"
    >
      <template v-slot:modal-title>
        <div v-if="item_selected.id <= 0">
          Add Department/Branch
          <!-- Thêm phòng ban/chi nhánh -->
        </div>
        <div v-else>
          Update Department/Branch
          <!-- Cập nhật phòng ban/chi nhánh -->
        </div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button v-if="item_selected.id <= 0" variant="success" @click="ok()"
          >
          Add
          <!-- Thêm -->
          </b-button
        >
        <b-button v-else variant="success" @click="ok()">
          Update
          <!-- Cập nhật -->
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Close
          <!-- Đóng -->
        </b-button>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Company ID
              <!-- Mã đơn vị -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="item_selected.madonvi"
              required
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Company
              <!-- Tên đơn vị -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="item_selected.tendonvi"
              required
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Belong to
              <!-- Thuộc đơn vị -->
            </label>
          </b-col>
          <b-col cols="9">
            <treeselect
              :disabled="item_selected.id > 0"
              v-model="item_selected.parentid"
              :options="items"
              placeholder
              :defaultExpandLevel="99999"
              :normalizer="normalizer"
            />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Address
              <!-- Địa chỉ -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="item_selected.diachi"
              required
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Note
              <!-- Ghi chú -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea
              v-model="item_selected.ghichu"
              rows="2"
            ></b-form-textarea>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ZkTable from "vue-table-with-tree-grid";
export default {
  name: "Departments",
  components: { Treeselect, ZkTable },
  data() {
    return {
      items: [],
      modalShow: false,
      item_null: {
        id: 0,
        parentid: null,
        madonvi: null,
        tendonvi: null,
        diachi: null,
        ghichu: null,
      },
      item_selected: {
        id: 0,
        parentid: null,
        madonvi: null,
        tendonvi: null,
        diachi: null,
        ghichu: null,
      },
      props: {
        stripe: false,
        border: true,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: true,
        isFold: false,
        expandType: false,
        selectionType: false,
      },
      columns: [
        {
          label: "Company",
          // label: "Tên đơn vị",
          prop: "tendonvi",
        },
        {
          label: "Company ID",
          // label: "Mã đơn vị",
          prop: "madonvi",
          width: "200px",
        },
        {
          label: "Address",
          // label: "Địa chỉ",
          prop: "diachi",
        },
        {
          label: "Note",
          // label: "Ghi chú",
          prop: "ghichu",
          width: "400px",
        },
        {
          label: "",
          prop: "action",
          type: "template",
          template: "action",
          width: "70px",
        },
        // {
        //   label: "Ghi chú",
        //   prop: "likes",
        //   minWidth: "200px",
        //   type: "template",
        //   template: "likes",
        // },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([axios.get("/api/department")])
      .then(
        axios.spread((department) => {
          next((vm) => vm.initData(department.data));
        })
      )
      .catch((err) => {
        next();
      });
  },
  computed: {
    //Permission create (button Them), edit/delete (action)
    department_create() {
      return this.$store.getters.hasPermission("department_create");
    },
    department_update() {
      return this.$store.getters.hasPermission("department_update");
    },
    department_delete() {
      return this.$store.getters.hasPermission("department_delete");
    },
  },
  methods: {
    normalizer(node) {
      if (node.childs != null) {
        return {
          id: node.id,
          label: node.tendonvi,
          children: node.childs,
        };
      } else {
        return {
          id: node.id,
          label: node.tendonvi,
        };
      }
    },
    initData(departments) {
      this.items = departments;
    },
    openItemModal() {
      this.item_selected = JSON.parse(JSON.stringify(this.item_null));
      this.modalShow = true;
    },
    openUpdateItemModal(data) {
      this.item_selected = JSON.parse(JSON.stringify(data));
      this.modalShow = true;
    },
    storeItem(bvModalEvt) {
      if (
        !(this.item_selected.madonvi && this.item_selected.madonvi.length) ||
        !(this.item_selected.tendonvi && this.item_selected.tendonvi.length)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item_selected.id <= 0) {
          axios
            .post("/api/department", this.item_selected)
            .then((res) => {
              this.$router.go(0);
              // this.modalShow = false;
              // this.items.push(res.data);
              // this.items.sort((a, b) =>
              //   a.code > b.code ? 1 : b.code > a.code ? -1 : 0
              // );
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/department", this.item_selected)
            .then((res) => {
              axios
                .get(`/api/department`)
                .then((response) => {
                  this.items = response.data;
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/department/${data.id}`)
                .then((res) => {
                  axios
                    .get(`/api/department`)
                    .then((response) => {
                      this.items = response.data;
                    })
                    .catch((err) => {
                      this.$toast.error(err.response.data, "Lỗi", {
                        timeout: 3000,
                      });
                    });
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.switch-list {
  margin: 20px 0;
  list-style: none;
  overflow: hidden;
}
.switch-item {
  margin: 20px;
  float: left;
}
</style>
<style>
.mytable th.zk-table__header-cell.zk-table--border-cell {
  background-color: #5384d1;
}
</style>
